import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { App, Button, Card, Popconfirm, Space, Table, Tag, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { api, apiError } from '@/lib/api';
import { formatDateTime } from '@/lib/format';
import { useAuthStore } from '@/lib/auth-store';
export function PeriodsPage() {
    const { message } = App.useApp();
    const qc = useQueryClient();
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const q = useQuery({
        queryKey: ['periods'],
        queryFn: async () => (await api.get('/periods')).data,
    });
    const closeMut = useMutation({
        mutationFn: async (id) => (await api.post(`/periods/${id}/close`)).data,
        onSuccess: () => {
            message.success('Periode ditutup');
            qc.invalidateQueries({ queryKey: ['periods'] });
        },
        onError: (e) => message.error(apiError(e)),
    });
    const cols = [
        {
            title: 'Periode',
            dataIndex: 'year_month',
            render: (v) => dayjs(v).format('MMMM YYYY'),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 140,
            render: (s) => s === 'OPEN' ? _jsx(Tag, { color: "success", children: "TERBUKA" }) : _jsx(Tag, { color: "volcano", children: "TERTUTUP" }),
        },
        {
            title: 'Ditutup Pada',
            dataIndex: 'closed_at',
            width: 200,
            render: (t) => (t ? formatDateTime(t) : '—'),
        },
        {
            title: 'Aksi',
            width: 180,
            render: (_, r) => r.status === 'OPEN' && hasPerm('period:close') ? (_jsx(Popconfirm, { title: "Tutup periode?", description: "Setelah ditutup, jurnal di periode ini tidak bisa diposting.", onConfirm: () => closeMut.mutate(r.id), children: _jsx(Button, { icon: _jsx(LockOutlined, {}), danger: true, size: "small", children: "Tutup Periode" }) })) : null,
        },
    ];
    return (_jsxs("div", { children: [_jsx(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: _jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Periode Akuntansi" }) }), _jsx(Card, { children: _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: false, size: "middle" }) })] }));
}
